var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-page',[_c('main-header',{attrs:{"back-href":_vm.backHref}}),_c('ion-content',{attrs:{"padding":""}},[_c('add-stripe-card',{on:{"complete":_vm.handleStripeAdded}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }